import React from 'react';

import {observer} from 'mobx-react';
import {SliderGameCardCompetitor} from "./slider.game-card.competitor";
import {SliderWidgetCardStatus} from "./slider-widget.card.status";
import {GamesSliderWidgetGameViewModel} from "../../../../../widgets/games-slider-widget/models/games-slider-widget.game-view-model";
import {SliderGameCardCenterText} from "./slider.game-card.center-text";
import {GameCardOdds, GameCardOddsProps} from "../../../odds/game-card-odds-row/game-card.odds";
import {ModuleController} from "../../../../../infrastructure/controllers/module-controller";
import {BaseMobxState} from "../../../../../infrastructure/mobx/base-mobx-state";
import {DeviceViewModel} from "../../../../models/device.view-model";
import {BaseProps} from "../../../../../infrastructure/models/props/base-props";
import {GameAggregate, GameAggregateProps} from "../../../game-aggregate/game.aggregate";
import {Link} from "../../../link/link";
import classNames from 'classnames';
import styles from '../../style/slider.module.scss';

export class SliderGameCardProps extends BaseProps {
  item: GamesSliderWidgetGameViewModel;
  showOdds: Boolean;
  isSmallView: Boolean;
  controller: ModuleController;
  state: BaseMobxState;
  device: DeviceViewModel;
  onMatchClickEvent: Function;
  blockInnerLinks: Boolean;
  use365Prefix: Boolean;
}

export const SliderGameCard = observer(({controller, item, use365Prefix, onMatchClickEvent, blockInnerLinks, showOdds, isSmallView, source, widgetName}: SliderGameCardProps) => {
  const {linkModel, odds, aggregateText, aggregateScore, homeCompetitor, awayCompetitor, centerText} = item;
  const containerProps = {
    model: use365Prefix && linkModel,
    className: classNames(styles.slider_widget_card, {[styles.slider_widget_card_clickable]: onMatchClickEvent && !blockInnerLinks}),
    onClick: () => onMatchClickEvent && onMatchClickEvent(item)
  }

  const gameCardOdds: GameCardOddsProps = {
    controller,
    game: item,
    odds,
    source,
    widgetName,
    gameOddsIsSmallView: true,
    showOdds
  }

  const aggregateProps: GameAggregateProps = {
    game: item,
    className: classNames(styles.slider_widget_card_description),
    aggregateText: aggregateText,
    aggregateScore: aggregateScore,
    homeCompetitorToQualify: homeCompetitor.toQualify,
    awayCompetitorToQualify: awayCompetitor.toQualify,
    shouldRenderAggregateScore: aggregateScore
  }

  return (
    <Link {...containerProps}>
      <div className={classNames(styles.slider_widget_card_main)}>
        <SliderGameCardCompetitor competitor={homeCompetitor} isSmallView={isSmallView}/>
        <div className={classNames(styles.slider_widget_card_center_content)}>
          <SliderWidgetCardStatus game={item}/>
          <SliderGameCardCenterText text={centerText}/>
          <GameAggregate {...aggregateProps} />
        </div>
        <SliderGameCardCompetitor competitor={awayCompetitor} isSmallView={isSmallView}/>
      </div>
      {
        showOdds && odds && <div className={classNames(styles.slider_widget_card_bottom)}>
          <GameCardOdds {...gameCardOdds} />
        </div>
      }
    </Link>
  )
});
